import { Toaster as ChakraToaster, Toast, createToaster, Stack } from '@chakra-ui/react';

export const toaster = createToaster({
  placement: 'bottom-end',
  pauseOnPageIdle: true,
  duration: 5000, // Default duration of 5 seconds
});

export const Toaster = () => {
  return (
    <ChakraToaster toaster={toaster}>
      {(toast) => (
        <Toast.Root minW="300px" maxW="450px">
          <Stack gap="1">
            <Toast.Title>{toast.title}</Toast.Title>
            {toast.description && (
              <Toast.Description>{toast.description}</Toast.Description>
            )}
          </Stack>
        </Toast.Root>
      )}
    </ChakraToaster>
  );
};
